// extracted by mini-css-extract-plugin
export default {"root":"_1avlK","top":"_3vIHf","bottom":"_2ZVJ5","middle":"_1ryet","indicators":"zDWAQ","right":"_3lVGi","engagement":"_3flg8"};